<template>
  <v-card>
    <v-card-title>
      <PageTitle :title="label('title')"/>
    </v-card-title>
    <v-divider/>
    <v-card-text style="height: 480px">
      <v-list>
        <v-list-item-group>
          <v-list-item v-for="(item, index) in items" :key="index">
            <v-list-item-icon>
              <UserImage icon :src="item.fromUser.icon"/>
            </v-list-item-icon>
            <v-list-item-content>
              <span v-html="item.description" />
              <span class="caption">{{fromNow(item.createdAt)}}</span>
            </v-list-item-content>
            <v-list-item-icon>
              <v-chip v-show="!item.isRead" color="error" class="font-weight-bold">new</v-chip>
            </v-list-item-icon>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card-text>
    <v-divider/>
    <v-card-actions>
      <v-container>
        <v-row no-gutters justify="end">
          <v-col cols="4" offset="4">
            <ActionButton type="close" icon="mdi-close" @click="close">{{label('close')}}</ActionButton>
          </v-col>
        </v-row>
      </v-container>
    </v-card-actions>
  </v-card>
</template>

<script>
  import PageTitle from "../../atoms/PageTitle";
  import UserImage from "../../atoms/UserImage";
  import ActionButton from "../../molecules/ActionButton";
  import ComponentMixin from "../../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "page",
    name: "NotificationPage",
    props: {
      items: {
        type: Array,
        required: true
      },
      close: Function
    },
    components: {
      PageTitle,
      UserImage,
      ActionButton
    }
  }
</script>

<style scoped>

</style>
